import React, { useCallback } from 'react'
import withList from './hoc/withList'
import ImageContainer from '../../../../components/image/image-container'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import ListProducts from './components/list-products'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { getStyleObjectFromString } from '../../../../utils/style'
import withObserver from '../hoc/withObserver'
import { FormattedMessage } from 'react-intl'
import { useApp } from '../../../../hooks/common'
import ViewMore from './components/view-more'


const getColorTheme = (htmlString) => {
    // 使用正则表达式提取 bg 和 color 属性值
    const bgMatch = htmlString.match(/bg="([^"]*)"/);
    const colorMatch = htmlString.match(/cl="([^"]*)"/);

    // 获取属性值，如果匹配不到则返回空字符串
    const bgValue = bgMatch ? bgMatch[1] : '';
    const colorValue = colorMatch ? colorMatch[1] : '';

    return {
        bg: bgValue,
        cl: colorValue
    }
}



const List8 = withList(withObserver(props => {
    useStyles(classes)
    const { products, data, sensors, innerRef } = props
    const isApp = useApp()

    const styles = getStyleObjectFromString(data?.style)

    const url = isApp ? data?.appHref : data?.href

    const aspectRatio = data?.width && data?.height ? `${data?.width} / ${data?.height}` : undefined

    const { bg, cl } = getColorTheme(data?.styledTitle || '')
    // const { bg, cl } = getColorTheme(`<span bg="#ECFFDF" cl="#222">${data?.styledTitle}</span>`)

    return <div ref={innerRef} id={data?.id} className={classes.List8Container} style={{ paddingTop: `${data?.marginTop}`, ...styles }}>

        {
            bg ? <div className={classes.BgTitle} style={{
                backgroundColor: bg,
            }}>
                <a style={{color: cl || '#222'}} href={url} dangerouslySetInnerHTML={{ __html: data.styledTitle }} />
            </div> : <>
                {
                    data?.styledTitle && <div className={classes.Title}>
                        <a href={url} dangerouslySetInnerHTML={{ __html: data.styledTitle }} />
                    </div>
                }
            </>
        }




        {
            data?.src && <ImageContainer className={classes.ListImage} style={{ aspectRatio }} href={url} sensors={{
                ...sensors,
                refId: data?.refId,
                type: '1',
            }} position={0}>
                <LazyLoadImage alt={data?.title} src={data?.src} />
            </ImageContainer>
        }

        <div className={classes.Bd}>
            <div className={classes.ListProducts}>
                <ListProducts sensors={
                    {
                        resourcepage_title: sensors?.title,
                        resource_position: sensors?.position,
                        resource_content: data?.refId,
                        resource_type: '1',
                    }
                } column={data?.refId} productCount={data?.productCount} products={products} />
            </div>
            <ViewMore className={classes.ViewAll} sensors={
                {
                    resourcepage_title: sensors?.title,
                    resource_position: sensors?.position,
                    resource_content: data?.refId,
                    resource_type: '1',
                }
            } href={url}>
                <FormattedMessage id="view_all" defaultMessage="View All" />{' >'}
            </ViewMore>
        </div>
    </div>
}))


export default props => <List8  {...props} data={{ ...props.data, productCount: 6 }} />